import { FC } from 'react'
import { ColorsButton } from '@buttons/ColorsButton/ColorsButton'
import { Box, useTheme } from '@mui/material'
import { authHeaderHooks } from '../../hooks/authHeaderHooks'
import { JoinUs } from '../popups/JoinUsScreen/JoinUs'

export const LoggedOutSection: FC = () => {
  const { closePopups, openJoinUs, closeJoinUs, isJoinUsOpen } = authHeaderHooks()
  const theme = useTheme()
  return (
    <>
      <Box component='div' sx={{ display: 'flex', padding: theme.spacing(1.5), fontSize: '14px' }}>
        <ColorsButton onClick={openJoinUs} title='Join Us' buttonSize='medium' backgroundColor={theme.palette.secondary.main} />
      </Box>

      <JoinUs isJoinUsOpen={isJoinUsOpen} closeJoinUs={closeJoinUs} closePopups={closePopups} />
    </>
  )
}
